export const prognosticHtml = {
  renderDate: (date, time) => {
    let dateTime = ''

    if (date) {
      dateTime = date
    }

    if (time) {
      dateTime += date ? ` • ${time}` : time
    }

    return `<span class="prognostics-card__time">${dateTime}</span>`
  },
  renderOddHtml: (odd, mobile = false, url = '') => {
    if (!odd) {
      return ''
    }

    if (mobile) {
      return `
        <div class="prognostics-card__footer-odd">
          <span>@${odd}</span>
        </div>
      `
    }

    return `
      <a class="prognostics-card__scoreboard-odd" href="${url}" rel="nofollow" target="_blank">
        <span>ODD</span>
        <span>@${odd}</span>
      </a>
    `
  },
  renderProbTip: prob_tip => {
    if (!prob_tip) {
      return ''
    }

    return `<span class="prognostics-card__scoreboard-probability">${clubei18n.prob} <strong>${Math.round(
      prob_tip * 100
    )}%</strong></span>`
  },

  render: ({ data }) => {
    return data
      .map(({ id, link, tips_info, title }) => {
        if (!tips_info || tips_info.length < 1) {
          return ''
        }

        const promo_info = tips_info[0]['promo_info'] || clubei18n.promo
        const scoreBoardActiveClass = ' prognostics-card__scoreboard-number--winner'
        const away_img = tips_info[0]['away_img'] || ''
        const away_name = tips_info[0]['away_name'] || ''
        const bookie_logo = tips_info[0]['bookie_logo'] || ''
        const bookie_url = tips_info[0]['bookie_url'] || ''
        const bookmaker_color = tips_info[0]['bookmaker_color'] || ''
        const button_color = tips_info[0]['button_color'] || ''
        const button_text = tips_info[0]['button_text'] || ''
        const home_img = tips_info[0]['home_img'] || ''
        const home_name = tips_info[0]['home_name'] || ''
        const league_name = tips_info[0]['league_name'] || ''
        const match_date_day = tips_info[0]['match_date_day'] || ''
        const match_date_hour = tips_info[0]['match_date_hour'] || ''
        const odds = tips_info[0]['odds'] || ''
        const tip = tips_info[0]['tip'] || ''
        const prob_tip = tips_info[0]['prob_tip'] || ''

        const one_class = tips_info[0]['1x2'] === '1' ? scoreBoardActiveClass : ''
        const x_class = tips_info[0]['1x2'] === 'X' ? scoreBoardActiveClass : ''
        const two_class = tips_info[0]['1x2'] === '2' ? scoreBoardActiveClass : ''

        return `
          <article
            class="prognostics-card"
            id="prognostic-${id}"
            style="--category-color: ${tips_info[0]['category_color'] || '#85c055'}"
          >
            <div class="prognostics-card__category-icon" style="background-image: url('${tips_info[0]['category_icon']}')"></div>
            <div class="prognostics-card__header">
              ${prognosticHtml.renderDate(match_date_day, match_date_hour)}
              <div class="prognostics-card__place-wrapp">
                <span class="prognostics-card__category-name">${tips_info[0]['category_name'] || ''}</span>
                <strong class="prognostics-card__championship">${league_name}</strong>
              </div>
              <a href="${link}" class="prognostics-card__link" title="Ir para ${title.rendered}">
                ${clubei18n.verPalpite}
              </a>
            </div>

            <div class="prognostics-card__team-wrapper">
              <div class="prognostics-card__team">
                <img src="${home_img}" alt="logo ${home_name}" class="prognostics-card__team-img">
                <span class="prognostics-card__team-name">${home_name}</span>
              </div>

              <div class="prognostics-card__team">
                <img src="${away_img}" alt="logo ${away_name}" class="prognostics-card__team-img">
                <span class="prognostics-card__team-name">${away_name}</span>
              </div>
            </div>

            <div class="prognostics-card__scoreboard-wrapper">
              <a class="prognostics-card__scoreboard-numbers" href="${bookie_url}" rel="nofollow" target="_blank">
                <span class="prognostics-card__scoreboard-number${one_class}">1</span>
                <span class="prognostics-card__scoreboard-number${x_class}">X</span>
                <span class="prognostics-card__scoreboard-number${two_class}">2</span>
              </a>

              <div class="prognostics-card__scoreboard-info">
                <div class="prognostics-card__scoreboard-winner">
                  <span class="prognostics-card__scoreboard-winner-label">${clubei18n.palpite}</span>
                  <strong class="prognostics-card__scoreboard-winner-tem">${tip}</strong>
                </div>
                ${prognosticHtml.renderProbTip(prob_tip)}

                ${prognosticHtml.renderOddHtml(odds, false, bookie_url)}
              </div>
            </div>

            <div class="prognostics-card__bet-wrapper" style="background-color: ${bookmaker_color}">
              <strong class="prognostics-card__bet-title">${promo_info}</strong>

              <div class="prognostics-card__bet-footer">
                <a href="${bookie_url}" rel="nofollow" target="_blank" class="prognostics-card__bet-link" style="background-color: ${button_color}">${button_text}</a>
                ${prognosticHtml.renderOddHtml(odds, true)}
                <img class="prognostics-card__bet-img" loading="lazy" src="${bookie_logo}" alt="">
              </div>
            </div>

            <a href="${link}" class="prognostics-card__footer-link" title="Ir para ${
          title.rendered
        }">${clubei18n.verPalpite}</a>
          </article>
        `
      })
      .join('')
  },
}
